import {createAction, props} from "@ngrx/store";
import {HttpErrorResponse} from "@angular/common/http";
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {StaffListDocument} from '@accounting/_common/models/staff-list-document.models';

export const CheckState = createAction(
    '[StaffListDocuments] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: StaffListDocument[] } }>()
);

export const LoadList = createAction(
    '[StaffListDocuments] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[StaffListDocuments] Load List Success',
    props<{ payload: { items: StaffListDocument[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[StaffListDocuments] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[StaffListDocuments] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetLoading = createAction(
    '[StaffListDocuments] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[StaffListDocuments] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpsertItemSuccess = createAction(
    '[StaffListDocuments] Upsert Item Success',
    props<{ payload: StaffListDocument }>()
);

export const DeleteItem = createAction(
    '[StaffListDocuments] Delete Item',
    props<{ payload: StaffListDocument }>()
);

export const DeleteItemSuccess = createAction(
    '[StaffListDocuments] Delete Item Success',
    props<{ payload: StaffListDocument }>()
);

export const DeleteItemFailure = createAction(
    '[StaffListDocuments] Delete Item Failure',
    props<{ payload: StaffListDocument }>()
);

export const SetInitialState = createAction(
    '[StaffListDocuments] Set Initial State'
);
